angular.module('vehicle-issue')
    .controller('VehicleIssueEditController', function (toastr, $scope, $rootScope, $uibModalInstance, VehicleIssue, VehicleIssueConst, data, VehicleService) {
        this.VehicleService = VehicleService
        this.$onInit = () => {
            this.item = angular.copy(data)
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let $promise
            $promise = VehicleIssue.save({id: this.item.vehicle.id}, this.item).$promise
            $promise
                .then(result => {
                    $rootScope.$broadcast(VehicleIssueConst.eventUpdate)
                    $uibModalInstance.close(result)
                    toastr.success("Zapisano")
                })
            return $promise
        }
    })
